import { DownloadPdfButton } from 'app/src/features/News/components/DownloadPdfButton'
import { newsApi } from 'app/src/services/welfareportal'
import { BreadCrumbClickableItemTemplate, BreadCrumbCurrentItemTemplate, PageWidget } from 'app/src/shared/components'
import { formatDate } from 'app/src/shared/helpers'
import { usePageTitle, useWebAppContext, useWelfarePortalNavigate } from 'app/src/shared/hooks'
import { Card } from 'primereact/card'
import type { MenuItem } from 'primereact/menuitem'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

export function NewsDetail() {
  const params = useParams()

  const context = useWebAppContext()
  const navigate = useWelfarePortalNavigate()
  const { t } = useTranslation('news')
  usePageTitle(t('News.Title'))
  const newsResp = newsApi.useNewsRequestGet(
    { pathParams: { id: params['newsId']! } },
    { meta: { context, preventGlobalError: true } },
  )
  useEffect(() => {
    const breadCrumbItems: MenuItem[] = [
      {
        template: () => BreadCrumbClickableItemTemplate({ label: t('News.BackHome'), command: navigate.goToLanding }),
      },
      {
        template: () => BreadCrumbClickableItemTemplate({ label: t('News.Title'), command: navigate.goToNews }),
      },
    ]

    if (newsResp?.data)
      breadCrumbItems.push({
        template: () => BreadCrumbCurrentItemTemplate({ label: newsResp?.data?.title }),
        className: 'line-clamp-1',
      })
    context.update({ breadCrumbItems: breadCrumbItems })
    //evita loop su contesto
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newsResp?.data, t])

  const title = (
    <div>
      {newsResp?.data && (
        <div className='flex justify-between'>
          <div>
            <p className='mb-4 pt-4 text-base text-black underline decoration-[var(--primary-color)] decoration-4 underline-offset-8'>
              {formatDate(newsResp?.data?.date)}
            </p>
          </div>
          {newsResp?.data.pdfLink && (
            <div className='flex justify-start'>
              <DownloadPdfButton newsItem={newsResp?.data} />
            </div>
          )}
        </div>
      )}
    </div>
  )

  if (newsResp?.isError) {
    throw newsResp.error
  } else
    return (
      <PageWidget background='cardBackGround' containerClassNamesOverrides='min-h-lvh'>
        {newsResp?.data && !newsResp.isError && (
          <div className='grid grid-rows-1'>
            <div className='my-10 grid grid-cols-12'>
              <Card
                title={title}
                pt={{ title: { className: 'text-left' } }}
                className='col-span-12 md:col-span-10 md:col-start-2'
              >
                <div dangerouslySetInnerHTML={{ __html: newsResp?.data.content }}></div>
              </Card>
            </div>
          </div>
        )}
      </PageWidget>
    )
}
